import { render, staticRenderFns } from "./CustomFieldDetailIcon.vue?vue&type=template&id=ebde9b82"
import script from "./CustomFieldDetailIcon.vue?vue&type=script&lang=ts"
export * from "./CustomFieldDetailIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports